module.exports = __webpack_public_path__ + "static/media/about-me-banner.d898af33.svg";